<ng-container *ngIf="isListVisible" class="h-full">

  <div *ngIf="rows.length" class="flex items-start pt-4 px-4 bg-white">
    <app-button id="btn-add-link" [isActive]="true" label="{{'data-sharing.create-link' | translate}}"
                class="mr-4 mt-0.5" innerTextClasses="py-1 px-1" (click)="onAddLink()"></app-button>

    <dsm-search-input class="grow" (searchChanged)="onSearchChanged($event)"
                      label="{{'data-sharing.search-label' | translate}}"></dsm-search-input>
  </div>

  <dsm-links-list-table *ngIf="rows.length" class="mx-3 tk-panel-bg h-full" [vehicles]="vehicles" [rows]="rows" [search]="this.search"
                        [isLoading]="isLoading" (viewLink)="onViewLink($event)" (reloadList)="onReloadList()">
  </dsm-links-list-table>

  <div *ngIf="!rows.length && !isLoading" class="empty-state">
    <div class="empty-state__wrapper">
      <img src="/assets/img/empty-state-share-links.svg" alt="">

      <span class="empty-state__wrapper__title">
        {{ 'emptyStateShareLinks' | translate }}
      </span>

      <p-button
        (onClick)="onAddLink()"
        [label]="'data-sharing.create-link'|translate"
        class="empty-state__wrapper__submit"
      />
    </div>
  </div>
</ng-container>

<dsm-link-view *ngIf="isAddLinkVisible" class="mr-5" [inputLinkViewModel]="linkToView"
               (linkAdded)="onLinkAdded($event)"></dsm-link-view>

